import * as yup from 'yup'
import { CompanyDto } from './companyDto'
import { AddressDto } from './address'

export class CompanyAddressDto extends AddressDto {
  email?: string = undefined
  phone?: string = undefined
  isBillingAddress?: boolean = false
  isBrokerCompanyAddress?: boolean = false
  isClusterConversionCompanyAddress?: boolean = false
  // isBuyerCompanyAddress?: boolean = false
  isDamageNotificationAddress?: boolean = false
  isExporterCompanyAddress?: boolean = false
  isImportLocationAddress?: boolean = false
  isInboundTransporterAddress?: boolean = false
  isInspectionCompanyAddress?: boolean = false
  // isInspectionCompanyAddress?: boolean = false
  isInsuranceUnderwriterCompanyAddress?: boolean = false
  // isLienHolderAddress?: boolean = false
  isMichiganSOSBranchAddress?: boolean = false
  isOutboundTransporterAddress?: boolean = false
  isPhysicalAddress?: boolean = false
  isRecallLocationAddress?: boolean = false
  isRegisteredImporterAddress?: boolean = false
  isShippingAddress?: boolean = false
  isSpecialMailerAddress?: boolean = false
  isTitleDestinationAddress?: boolean = false
  isVehicleDestinationAddress?: boolean = false
  company?: CompanyDto = undefined
}

export const companyAddressValidationSchema = yup.object({
  addressNickname: yup.string().max(200, 'Address Nickname cannot be more than 200 characters.').required('Address Nickname is required.'),
  phone: yup.string().max(200, 'Phone cannot be more than 200 characters.').nullable(),
  email: yup.string().max(320, 'Email cannot be more than 320 characters.').nullable(),
  address1: yup.string().max(200, 'Address 1 cannot be more than 200 characters.').required('Address 1 is required.'),
  address2: yup.string().max(200, 'Address 2 cannot be more than 200 characters.').nullable(),
  city: yup.string().max(200, 'City cannot be more than 200 characters.').required('City is required.'),
  county: yup.string().max(200, 'County cannot be more than 200 characters.').nullable(),
  stateProvince: yup.string().max(200, 'State / Province cannot be more than 200 characters.').required('State / Province is required.'),
  postalCode: yup.string().max(200, 'Postal Code cannot be more than 200 characters.').required('Postal Code is required.'),
  country: yup.string().max(200, 'Country cannot be more than 200 characters.').required('Country is required.'),
  isActive: yup.boolean(),
  isBillingAddress: yup.boolean(),
  isBrokerCompanyAddress: yup.boolean(),
  // isBuyerCompanyAddress: yup.boolean(),
  isDamageNotificationAddress: yup.boolean(),
  isExporterCompanyAddress: yup.boolean(),
  isImportLocationAddress: yup.boolean(),
  // isInspectionCompanyAddress: yup.boolean(),
  isInsuranceUnderwriterCompanyAddress: yup.boolean(),
  // isLienHolderAddress: yup.boolean(),
  isMichiganSOSBranchAddress: yup.boolean(),
  isPhysicalAddress: yup.boolean(),
  isRecallLocationAddress: yup.boolean(),
  isRegisteredImportAddress: yup.boolean(),
  isShippingAddress: yup.boolean(),
  isSpecialMailerAddress: yup.boolean(),
  isTitleDestinationAddress: yup.boolean(),
  isVehicleDestinationAddress: yup.boolean()
})
